export function formatArrayQueryParams(...args) {
    return args.reduce((acc, [key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
            acc[key] = value.join(',');
        }
        return acc;
    }, {});
}
